import(/* webpackMode: "eager" */ "/app/src/lib/translate/i18n/client.ts");
;
import(/* webpackMode: "eager" */ "/app/src/lib/translate/i18n/i18n-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/components/BusinessLanding/BusinessFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/components/BusinessLanding/BusinessHero.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/components/BusinessLanding/FutureServices.tsx");
